// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d5ace554","488":"b20b4a3d","977":"294b426a"}[chunkId] + ".chunk.js";
};